import common from '@/utils/common'
import { SummaryLine, EarlyBird, DiscountBox } from '@/style-guide'
import { Button, Divider, Typography } from 'antd'
import { getServiceFee } from '@/utils/InvoiceHelper'
import { useState } from 'react'

const { Text } = Typography
export const BookingSummary = ({ booking, trip }) => {
  const {
    rooms,
    addOns,
    totalFare,
    coupon,
    discountBaseFare,
    discountAddonFare,
    pendingAmount,
    createdAt,
    paidAmout,
    deposit,
    attendees,
    currentDue,
    status,
    discounts,
    totalPlatformFee,
    totalPaymentProcessingFee,
  } = booking || {}
  // console.log('booking', booking)
  // console.log('trip', trip) 
  const { platformFee, cardFee } = getServiceFee(booking, trip)
  let discountAmount = totalFare - discountBaseFare - discountAddonFare
  let subTotal = totalFare
  let couponDiscountAmount = 0
  const [openBookingPaidDetails, setOpenBookingPaidDetails] = useState(false);
  if (coupon) {
    couponDiscountAmount =
      coupon.discType == 'percentage'
        ? (subTotal * (coupon.amount || 0)) / 100
        : coupon.amount || 0
  }
  const getPaymentTerms = () => {
    if (booking?.paymentStatus == 'deposit') {
      if (trip?.deposit?.includeAddOns) {
        return `Deposit x ${booking.attendees} + add-ons`
      }
      return `Deposit x ${booking.attendees}`
    }
    return 'Full payment'
  }
  if (!rooms || rooms.length === 0) {
    return null;
  }
  return (
    rooms &&
    rooms.length > 0 && (
      <div>
        <Divider />
        {/* <Typography.Title level={4} className="margin-top-10">
          Booking details
        </Typography.Title> */}
        {/* <div className='booking-details-date'>{common.showDate(createdAt)}</div> */}

        {rooms && rooms.length > 0 && (
          <div className='booking-summary-block'>
            <div className='booking-summary-title'>Booking options</div>
            {console.log('rooms', rooms)}
            {rooms.map((room, idx) => (
              <SummaryLine key={`room_${idx}`}>
                <Text>
                  <span className='booking-summary-attendees'>{room.attendees || 1}x</span> {room?.name || 'N/A'} - {room.roomName || 'N/A'}
                </Text>
                <Text style={{ fontWeight: 'bold' }}>
                  {common.toCurrency(room?.cost * (room.attendees || 1))}
                </Text>
              </SummaryLine>
            ))}
          </div>
        )}
        {addOns && addOns.length > 0 && (
          <div className='booking-summary-block'>
            <div className='booking-summary-title'>Add-ons</div>
            {addOns.map((item, index) => (
              <SummaryLine key={`addons-${index}`}>
                <Text>
                  <span className='booking-summary-attendees'>{item.attendees || 1}x</span> {item.addOn.name} - {item.variant.name}
                </Text>
                <Text style={{ fontWeight: 'bold' }}>
                  {common.toCurrency(item.variant.cost * (item.attendees || 1))}
                </Text>
              </SummaryLine>
            ))
            }
          </div>
        )}
        {totalFare ? 
        <>
        <Typography.Title level={5}>
          <SummaryLine className="margin-top-10">
            <Text>Total</Text>
            <Text style={{ fontWeight: 'bold' }}>{totalFare ? common.toCurrency(totalFare) : '$0'}</Text>
          </SummaryLine>
        </Typography.Title>
        <Divider />
        </>
        : <>  </>}

        {discounts && discounts.length > 0 && (
          <>
            <SummaryLine className="margin-top-10">
              <Text>Discount</Text>
            </SummaryLine>
            {discounts?.map((d) => (
              <SummaryLine className="margin-top-10" key={d.name}>
                <EarlyBird>
                  <DiscountBox>{d.name}</DiscountBox>
                </EarlyBird>
                <Text style={{ fontWeight: 'bold' }}>
                  - {d.discType === 'amount' && '$'}
                  {d.amount}
                  {d.discType === 'percentage' && '%'}{' '}
                </Text>
              </SummaryLine>
            ))}
            {couponDiscountAmount > 0 && (
              <SummaryLine className="margin-top-10">
                <EarlyBird>
                  <DiscountBox>{coupon.couponCode}</DiscountBox>
                </EarlyBird>
                <Text style={{ fontWeight: 'bold' }}>
                  - {coupon.discType === 'amount' && '$'}
                  {coupon.amount}
                  {coupon.discType === 'percentage' && '%'}{' '}
                </Text>
              </SummaryLine>
            )}
            {discountAmount + couponDiscountAmount > 0 && (
              <SummaryLine className="margin-top-10">
                <div></div>
                <Text style={{ borderTop: '1px solid', fontWeight: 'bold' }}>
                  -{common.toCurrency(discountAmount + couponDiscountAmount)}
                </Text>
              </SummaryLine>
            )}
          </>
        )
        }
        {/* {!openBookingPaidDetails && <div style={{ marginTop: '10px' }}><Button onClick={() => setOpenBookingPaidDetails(true)}>View Commissions & Total</Button></div>} */}
        <div>
          {
            (totalPlatformFee > 0 || platformFee > 0) && (
              <SummaryLine style={{ marginTop: '10px' }}>
                <Text>Platform service charge</Text>
                <Text style={{ fontWeight: 'bold' }}>
                  + {common.toCurrency(totalPlatformFee || platformFee || 0)}
                </Text>
              </SummaryLine>
            )
          }
          {
            (totalPaymentProcessingFee > 0 || cardFee > 0) && (
              <SummaryLine style={{ marginTop: '10px' }}>
                <Text>Payment processing charge</Text>
                <Text style={{ fontWeight: 'bold' }}>
                  + {common.toCurrency(totalPaymentProcessingFee || cardFee || 0)}
                </Text>
              </SummaryLine>
            )
          }
          <Typography.Title level={5}>
            <SummaryLine className="margin-top-10">
              Booking total
              <span style={{ fontWeight: 'bold' }}>
                {(pendingAmount + currentDue + paidAmout) ? common.toCurrency(pendingAmount + currentDue + paidAmout) : '$0'}
              </span>
            </SummaryLine>
          </Typography.Title>
          {
            currentDue > 0 && (
              <>
                <Divider />
                <SummaryLine>
                  <Text className="success">Current Due</Text>
                  <Text className="success">{common.toCurrency(currentDue)}</Text>
                </SummaryLine>
                {status == 'pending' && (
                  <SummaryLine>
                    <Text style={{ fontWeight: 'bold' }} size={12}>({getPaymentTerms()})</Text>
                  </SummaryLine>
                )}
              </>
            )
          }

          {
            pendingAmount > 0 && (
              <>
                <Divider />
                <SummaryLine>
                  <Text>Total outstanding to date</Text>
                  <Text style={{ fontWeight: 'bold' }}>{common.toCurrency(pendingAmount)}</Text>
                </SummaryLine>
              </>
            )
          }

          {
            paidAmout > 0 && (
              <>
                <Divider />
                <SummaryLine>
                  <Text>Total paid to date</Text>
                  <Text style={{ fontWeight: 'bold' }}>{common.toCurrency(paidAmout)}</Text>
                </SummaryLine>
              </>
            )
          }
          {
            deposit && paidAmout > 0 && pendingAmount > 0 && (
              <>
                <SummaryLine>
                  <Text>Paid deposit x {attendees}</Text>
                  <Text style={{ fontWeight: 'bold' }}>{common.toCurrency(deposit.amount * attendees)}</Text>
                </SummaryLine>
                {deposit.includeAddOns && (
                  <SummaryLine>
                    <Text>Paid add-ons</Text>
                    <Text style={{ fontWeight: 'bold' }}>{common.toCurrency(discountAddonFare)}</Text>
                  </SummaryLine>
                )}
              </>
            )
          }
        </div>
      </div >
    )
  )


}
